import { george, pr, ui } from "aaa";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import * as React from "react";
import { IconCalendar } from "components/util/primitives";
import { pushRoute } from "stores/RouterFunctions";
import { AppointmentRoutes } from "components/appointment/AppointmentRoutes";


export const SavingsOptionsAppointmentCard = ({ isMobile, style }: { isMobile?: boolean; style?: React.CSSProperties }) => {

    const handleClickMakeAppointment = () => {
        pushRoute(AppointmentRoutes.TOPIC, true);
    };

    return (
        <george.Card
            disableTopSpacing
            style={{
                borderRadius: 8,
                boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.05)",
                padding: 32,
                ...style
            }}
        >
            <pr.P_18_TITLE style={{ lineHeight: "24px", fontWeight: 700 }}>
                {ui.__("savingsOptions.overview.card.appointment.title")}
            </pr.P_18_TITLE>
            <pr.P_16_CONTENT style={{ lineHeight: "24px", marginTop: 8 }}>
                {ui.__("savingsOptions.overview.card.appointment.text")}
            </pr.P_16_CONTENT>
            <GdsFakeActionButton
                onClick={handleClickMakeAppointment}
                style={{ display: isMobile ? undefined : "inline-block", borderRadius: 8, marginTop: 16 }}
                innerStyle={{ display: "flex", alignItems: "center", justifyContent: isMobile ? "center" : undefined, gap: 8 }}
            >
                <span>
                    <IconCalendar style={{ width: 24, height: 24, display: "block" }} />
                </span>
                <span>{ui.__("savingsOptions.overview.card.appointment.button")}</span>
            </GdsFakeActionButton>
        </george.Card>
    );
};


// WEBPACK FOOTER //
// ./src/components/savingsOptions/components/SavingsOptionsAppointmentCard.tsx